// extracted by mini-css-extract-plugin
export default {"video":"Video-module--video--1FWrP"};